import { useState } from 'react';
import { fromNullable } from 'maybeasy';
import LearningCollectionEditStore from '../../../../../Edit/Store';
import { LearningDesignSection } from '../../../../../Types';
import {
  sectionName,
  sectionDescription,
  sectionDisplayType,
  sectionDisplayButtonLabel,
} from './FormHelpers';
import { CloseAction } from '../../../../../../../Modal/UseOpenable';

const useLearningDesignDetailsForm = (
  section: LearningDesignSection,
  close: CloseAction,
  store: LearningCollectionEditStore,
) => {
  const [formName, setFormName] = useState<string>(sectionName(section));
  const [formDescription, setFormDescription] = useState<string>(sectionDescription(section));
  const [formDisplayType, setFormDisplayType] = useState<string>(sectionDisplayType(section));
  const [formDisplayButtonLabel, setFormDisplayButtonLabel] = useState<string>(
    sectionDisplayButtonLabel(section),
  );

  const save = () => {
    store.updateSectionTemplate(
      section,
      formName,
      formDescription,
      formDisplayType,
      formDisplayButtonLabel,
    );
    close();
  };

  const isSaveDisabled = !fromNullable(formName).isJust();

  return {
    formName,
    setFormName,
    formDescription,
    setFormDescription,
    formDisplayType,
    setFormDisplayType,
    formDisplayButtonLabel,
    setFormDisplayButtonLabel,
    save,
    isSaveDisabled,
  };
};

export default useLearningDesignDetailsForm;
